package com.karyadina.util

import kotlinx.browser.window
import kotlin.js.Date

actual fun getCurrentTimeMs(): Long = Date().getTime().toLong()

actual fun openPlayStore(url: String) {
    window.open(url, "_blank")
}
